export enum OrderIsolationTypes {
    SpouwMuurIsolatie = "Spouwmuurisolatie",
    VloerIsolatie = "Vloerisolatie",
    DakIsolatie = "Dakisolatie",
    IsolatieGlas = "Isolatieglas",
    Impregneren = "Impregneren",
}
